<template>
  <div>
    <form id="form" @submit.prevent="">
      <div class="form-group">
        <label>وضعیت</label>
        <div class="radio-inline">
          <label class="radio">
            <input type="radio" value="1" v-model="form.status" />
            <span></span>
            روشن
          </label>
          <label class="radio">
            <input type="radio" value="0" v-model="form.status" />
            <span></span>
            خاموش
          </label>
        </div>
        <span class="form-text text-muted">choose touch panel status</span>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "TP1",
  data() {
    return {
      form: {}
    };
  },
  computed: {
    ...mapGetters(["device"]),
    originalForm() {
      let status = this.device.status.toString();
      status = status === "" ? "0" : status;

      return {
        status: status
      };
    }
  },
  beforeMount() {
    this.form = _.cloneDeep(this.originalForm);
  },
  watch: {
    form: {
      handler() {
        // if (_.isEqual(this.form, this.originalForm) === false) {
        this.$emit("change-form", this.form.status);
        // }
      },
      deep: true
    }
  }
};
</script>
